module.exports = __webpack_public_path__ + "img/counter-light.94c711a8.png";